import { getItemsFromCollection } from "directus/src/operations";
import { formatDateForAPI } from "utils/utils";

export async function fetchUnloggedDays({ startDate }) {
  try {
    const response = await getItemsFromCollection("daily_work_capacity", {
      aggregate: { countDistinct: ["id"] },
      filter: {
        employee: { user: { _eq: "$CURRENT_USER" } },
        date: { _gte: startDate, _lt: formatDateForAPI(new Date()) },
        payroll_hours: { _gt: 0 },
        is_logged: { _eq: false },
      },
      // limit: -1,
    });

    return response?.[0]?.countDistinct.id || 0;
  } catch (error) {
    console.error(error);
    throw error;
  }
}
